import React from 'react'
import PropTypes from 'prop-types'

import {
  BACK_TO_DASHBOARD,
  LICENSE_LABEL,
  LICENSE_PLACEHOLDER,
} from './constants'
import BackLink from 'components/BackLink'
import {
  Background,
  LicenseSelect,
  ReportsBannerBody,
  ReportsBannerHeader,
  ReportsBannerInnerWrapper,
  ReportsBannerWrapper,
  TextInnerWrapper,
} from './component.styles'
import { getSiteOption } from 'utils/productHelpers'

const ReportsBanner = ({
  activeSelaSites,
  navigateToDashboardOnClick,
  onLicenseChange,
  selectedLicense,
  title,
  body,
}) => {
  const siteOptions = activeSelaSites.map(site => getSiteOption(site))
  const siteTextOptions = siteOptions.map(site => site.text)
  const selectedLicenseId = selectedLicense?.id
  const [selectedValue] = siteTextOptions.filter(option =>
    option.includes(selectedLicenseId),
  )
  const singleLicense = siteTextOptions.length < 2

  return (
    <ReportsBannerWrapper>
      <Background />
      <ReportsBannerInnerWrapper singleLicense={singleLicense}>
        <BackLink
          dataTestId="accessible-link-navigate-to-dash"
          onClick={navigateToDashboardOnClick}
        >
          {BACK_TO_DASHBOARD}
        </BackLink>
        <TextInnerWrapper>
          <ReportsBannerHeader dataTestId="banner-title">
            {title}
          </ReportsBannerHeader>
          <ReportsBannerBody dataTestId={body?.type}>
            {body?.text}
          </ReportsBannerBody>
        </TextInnerWrapper>
        {!singleLicense && (
          <LicenseSelect
            autoComplete={false}
            autofocus
            dataTestId="select-site"
            disabled={false}
            label={LICENSE_LABEL}
            name="selectedLicense"
            onChange={onLicenseChange}
            options={siteTextOptions}
            placeholder={LICENSE_PLACEHOLDER}
            value={selectedValue}
          />
        )}
      </ReportsBannerInnerWrapper>
    </ReportsBannerWrapper>
  )
}

ReportsBanner.propTypes = {
  activeSelaSites: PropTypes.array,
  body: PropTypes.object,
  navigateToDashboardOnClick: PropTypes.func,
  onLicenseChange: PropTypes.func,
  selectedLicense: PropTypes.object,
  title: PropTypes.string,
}

ReportsBanner.defaultProps = {
  activeSelaSites: [],
}

export default ReportsBanner
